import { Component, Input } from "@angular/core";
import { NumberFormatHelper } from "app/core/helpers/number-format.helper";

@Component({
    selector: "app-tooltip-template-costs",
    templateUrl: "./tooltip-template-costs.component.html",
    styleUrls: ["./tooltip-template-costs.component.scss"],
    standalone: false
})
export class CostsTooltipTemplate {
  constructor() {}
}
